module.exports = __webpack_public_path__ + "static/media/Powered_by_Badge_white.3f998d45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/brands/digitalocean/Powered_by_Badge_white.svg
// module id = 62
// module chunks = 0